import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type { TaskList, TaskListCollection } from './taskList.types';

const useBulkSelectedTasks = (taskIds: number[]) => {
  const getTaskQuery = useCallback(
    (collection: TaskListCollection) =>
      collection?.find({ selector: { pkAssetInspectionTask: { $in: taskIds } } }),
    [taskIds],
  );

  const { result, isFetching: isTaskDetailLoading } = useRxData<TaskList>(
    RxdbCollectionName.TASK_LIST,
    getTaskQuery,
  );

  const taskList: TaskList[] = result?.length
    ? JSON.parse(JSON.stringify(result))
    : ([] as TaskList[]);

  return { taskList, isTaskDetailLoading };
};

export default useBulkSelectedTasks;
